// Scripts librairies
import { docReady } from './js/libs/utils'

// Charge la base commune
require('./common.js')

// model Like
function getModelLike (btn) {
  import(/* webpackChunkName: "modelLike" */ './js/components/modelLike.js').then(module => {
    module.modelLike.init(btn)
    document.getElementById('likeModel').click()
  })
}

docReady(function () {
//  console.log('Models template')

  // gestion des filtres depuis la navbar
  const $mn = document.getElementById('sub-nav')
  const $h = document.getElementById('header')
  const openHeader = function () {
    const stickyEl = $mn.closest('.sticky-top')
    if ($h.querySelector('.navbar-collapse').classList.contains('show')) {
      stickyEl.style.zIndex = '999'
    } else {
      stickyEl.style.zIndex = '1020'
    }
  }
  $h.querySelector('.navbar-toggler[data-trigger]').addEventListener('click', openHeader)
  $h.querySelector('.navbar-close').addEventListener('click', openHeader)
  if ($mn && $mn.querySelector('.navbar-toggler[data-trigger]')) {
    const openSubnav = function () {
      const stickyEl = $mn.closest('.sticky-top')
      if ($mn.querySelector('.navbar-collapse').classList.contains('show')) {
        stickyEl.style.zIndex = '1020'
      } else {
        stickyEl.style.zIndex = '999'
      }
    }
    $mn.querySelector('.navbar-toggler[data-trigger]').addEventListener('click', openSubnav)
    $mn.querySelector('.navbar-close').addEventListener('click', openSubnav)
  }

  // gestion des likes
  const btn = document.getElementById('likeModel')
  if (btn) {
    btn.addEventListener('click', () => {
      getModelLike(btn)
    })
  }
})
